import loadImage from "image-promise";

document.addEventListener(
	"transitionFinished",
	() => {
		init();
	},
	false
);

document.addEventListener(
	"initialLoadFinished",
	() => {
		init();
	},
	false
);

document.addEventListener(
	"loadedMoreNews",
	() => {
		init();
	},
	false
);

const SELECTOR = ".has-animation";
const ANIMATE_CLASS_NAME = "animate";

const init = () => {
	// get only these elements, which are not animated yet
	const elements = [].filter.call(
		document.querySelectorAll(SELECTOR),
		(element) => !isAnimated(element, ANIMATE_CLASS_NAME)
	);

	// start observing your elements
	elements.forEach((element) => intersectionObserver.observe(element));
};

const animate = (element) => element.classList.add(ANIMATE_CLASS_NAME);

const isAnimated = (element) => element.classList.contains(ANIMATE_CLASS_NAME);

const options = {
	rootMargin: "0px 0px -33%",
};

const intersectionObserver = new IntersectionObserver((entries, observer) => {
	entries.map((entry) => {
		if (entry.isIntersecting) {
			// console.log(entry.target);

			if (entry.target.dataset.src) {
				entry.target.src = entry.target.dataset.src;
			}

			if (entry.target.dataset.srcset) {
				entry.target.srcset = entry.target.dataset.srcset;
			}

			entry.target.removeAttribute("data-src");
			entry.target.removeAttribute("data-srcset");

			loadImage(entry.target).then(animate(entry.target));

			observer.unobserve(entry.target);
		}
	});
}, options);
